import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cpu",
  "use": "cpu-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"cpu\"><path d=\"M11 2L9.22 8H14l-7 8 1.78-6H4l7-8zm0-1.5c-.42 0-.84.18-1.13.51l-7 8c-.39.44-.48 1.07-.24 1.61s.78.88 1.37.88h2.77l-1.21 4.07a1.505 1.505 0 001.43 1.93c.42 0 .84-.18 1.13-.51l6.96-7.96a1.498 1.498 0 00-1.09-2.53H14h-2.77l1.21-4.07A1.505 1.505 0 0011 .5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol